import React, { Component } from 'react';
import dateFormat from 'dateformat';
import { Buttons } from '../../ui/index';
import { ConfirmDeleteDialogue } from '../../ui/ConfirmDeleteDialogue';
import Ionicon from "react-ionicons";

export default class EndorsementItemPending extends Component {
    constructor (){
        super();
        this.state = {
            isOpen: false,
        }
    }
    render () {
        const { body } = this.props, { first_name, last_name, email_address, created_at } = body;
        return (
            <div className="item-endorsements">
                <div className="row">
                    <div className="col-xs-12 col-md-8 col-lg-9 new-profile-info">
                        <ul className="endorser-details">
                            <li>
                                <Ionicon icon="ion-person"/>
                                <h5 className="h5 endorser-name">{ first_name } { last_name }</h5>
                            </li>
                            <li>
                                <Ionicon icon="ion-at"/>
                                <p className="p-tag endorser-email">{ email_address }</p>
                            </li>
                            <li>
                                <Ionicon icon="ion-calendar"/>
                                <p className="p-tag endorser-date"><span>Requested on: </span>{dateFormat( created_at, 'dd mmm yyyy' )}</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-12 col-md-4 col-lg-3 new-profile-controls">
	                    {!this.state.isOpen &&
                        <Buttons.EndorsementsDeleteButton
                            handleClick={ () => this.setState({isOpen: true}) }
                            text="Cancel request"/>
	                    }
                        <ConfirmDeleteDialogue
                            isOpen={ this.state.isOpen }
                            onCancel={ () => this.setState({ isOpen: false } ) }
		                    {...this.props }/>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/EndorsementItemPending.js